"use strict";

import geocode from "vwa/geocode";
import dispatcher from "./../dispatcher";
import dataTypeStore from "./../store/dataTypes";
import storeAddress from "./storeAddress";

export default async function resolveCarrierState(carrierState) {
	const state = carrierState.state;
	const positionId = dataTypeStore.get("Position")._id;
	const position = state.find(data => data.dataType == positionId);
	if (!position)
		return;
	if (position.address)
		return;
	const address = await resolve(position.point);
	position.address = address;
	storeAddress(position.point, address);
}

async function resolve(point) {
	if (!point) return;
	let address = null;
	try {
		address = await geocode('nominatim', point);
	} catch (e) {
		try {
			address = await geocode('google', point);
		} catch (e) {}
	}
	
	return address;
}


// WEBPACK FOOTER //
// ./src/api/resolveCarrierState.js